import { Table } from 'antd';
import { useEffect } from 'react';
import { useStoreState, useStoreActions } from '../../../store';
import type { Simulation, SimulationSellRateZoneMapping } from '../../../store/simulation/types';
import { CheckCircleOutlined, CloseCircleOutlined } from '@ant-design/icons';
import type { ColumnsType } from 'antd/lib/table';
export interface SimulationSellZoneMappingTableProps {
  simulation: Simulation;
  sellCarrierRateId: string;
}

export const SimulationSellZoneMappingTable = ({
  simulation,
  sellCarrierRateId,
}: SimulationSellZoneMappingTableProps) => {
  const fetchSimulationZoneMappings = useStoreActions(
    (actions) => actions.simulation.fetchSimulationSellRateZoneMappings,
  );
  const simulationSellRateZoneMappings = useStoreState((state) => state.simulation.simulationSellRateZoneMappings);

  useEffect(() => {
    if (!simulationSellRateZoneMappings[`${simulation.simulationId}_${sellCarrierRateId}`]) {
      fetchSimulationZoneMappings({ simulationId: simulation.simulationId, sellCarrierRateId });
    }
  }, [simulation, simulationSellRateZoneMappings, fetchSimulationZoneMappings, sellCarrierRateId]);

  const columns: ColumnsType<SimulationSellRateZoneMapping> = [
    {
      title: 'Carrier Selection Zone',
      key: 'zoneId',
      dataIndex: 'zoneId',
      sorter: (a, b) => a.zoneId.localeCompare(b.zoneId),
    },
    {
      title: 'Zone Count',
      key: 'count',
      dataIndex: 'count',
      sorter: (a, b) => a.count - b.count,
    },
    {
      title: 'Mapping Present',
      key: 'mapped',
      sorter: (a, b) => (a.mapped ? 1 : -1) - (b.mapped ? 1 : -1),
      render: (val) => {
        return val.mapped ? (
          <CheckCircleOutlined style={{ color: 'green' }} />
        ) : (
          <CloseCircleOutlined style={{ color: 'red' }} />
        );
      },
    },
    {
      title: 'Mapped Sell Zone',
      key: 'sellRateZoneId',
      dataIndex: 'sellRateZoneId',
      sorter: (a, b) => (a.mapped ? 1 : -1) - (b.mapped ? 1 : -1),
    },
  ];

  return (
    <Table
      size={'small'}
      columns={columns}
      dataSource={simulationSellRateZoneMappings[`${simulation.simulationId}_${sellCarrierRateId}`]}
      pagination={false}
      bordered={false}
    />
  );
};
